module.exports = __webpack_public_path__ + "img/chubbhogar-1-full.dfe312d5.png";